import { Text, TextType } from 'ui-components/components/text';

import style from './customer-section-header-content.module.css';
import { usePickupRelayOrderInfoBySalesOrderId } from '../../../../hooks/orders/use-pickup-relay-order-check';
import { customerMessages } from '../../../../orders/customer-recipient-widget/component';
import PickupRelayTooltip from '../../../../orders/customer-recipient-widget/pickup-relay-tooltip';

/**
 * @param {object} props
 * @param {string} props.salesOrderId
 * @returns {JSX.Element}
 */
export const CustomerSectionHeaderContent = ({ salesOrderId }) => {
  const isPickupRelayOrder = usePickupRelayOrderInfoBySalesOrderId(salesOrderId) !== null;

  const messageDescriptor = isPickupRelayOrder ? customerMessages.pudoHeader : customerMessages.header;

  return (
    <>
      <Text textType={TextType.H4} value={messageDescriptor} />
      {isPickupRelayOrder ? <PickupRelayTooltip tooltipTargetWrapperClassName={style['pickup-relay-tooltip-target']} /> : null}
    </>
  );
};
